import { useEffect } from 'react';

interface IUseScrollLockProps {
    isLocked: boolean;
}

export const useScrollLock = ({ isLocked }: IUseScrollLockProps) => {
    useEffect(() => {
        if (isLocked && document) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isLocked]);
};
